import { useEffect, useRef } from "react";
import apiRoutes from "../../api/routes";
import useApiRequest from "../../api/api";
import { useUser } from "../../context/user-context";

// const useFetchUserProfile = () => {
//   const { user, updateUser } = useUser();
//   const { makeApiCall } = useApiRequest();
//   const hasFetchedOnce = useRef(new Set()); // Track URLs that have been fetched once
//   const hasMounted = useRef(false); // Prevents double execution on mount

//   const fetchUserProfile = async () => {
//     const storedUser = JSON.parse(localStorage.getItem("user"));

//     if (!storedUser || Object.keys(storedUser).length === 0) {
//       await fetchGuestUser();
//     } else {
//       const url = apiRoutes.profile.account;
//       if (!hasFetchedOnce.current.has(url)) {
//         try {
//           const response = await makeApiCall(url, "GET");
//           if (response?.data && response?.success) {
//             const updatedUser = {
//               ...user,
//               ...response.data,
//               authToken: user.authToken,
//               refreshToken: user.refreshToken,
//             };
//             updateUser(updatedUser);
//             localStorage.setItem("user", JSON.stringify(updatedUser));
//           }
//           hasFetchedOnce.current.add(url);
//         } catch (error) {
//           console.error("Failed to fetch user profile:", error);
//         }
//       }
//     }
//   };

//   useEffect(() => {
//     if (hasMounted.current) return; // Prevent running twice
//     hasMounted.current = true;

//     fetchUserProfile(); // Call only once on mount

//     const interval = setInterval(fetchUserProfile, 5 * 60 * 1000);
//     return () => clearInterval(interval);
//   }, [makeApiCall, apiRoutes.profile.account, updateUser]);
// };

// export default useFetchUserProfile;
// 👇 Move these outside the hook so they can be reused
export const fetchUserProfileLogic = async ({
  makeApiCall,
  updateUser,
  user,
}) => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const fetchGuestUser = async () => {
    const response = await makeApiCall(apiRoutes.auth.guest, "POST");
    localStorage.setItem("user", JSON.stringify(response.data));
    updateUser(response.data);
  };
  try {
    if (!storedUser || Object.keys(storedUser).length === 0) {
      await fetchGuestUser();
    } else {
      const url = apiRoutes.profile.account;

      const response = await makeApiCall(url, "GET");
      if (response?.data && response?.success) {
        const updatedUser = {
          ...user,
          ...response.data,
          authToken: user.authToken,
          refreshToken: user.refreshToken,
        };
        updateUser(updatedUser);
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }
    }
  } catch (error) {
    console.error("Failed to fetch user profile:", error);
  }
};

// Your hook stays the same
const useFetchUserProfile = () => {
  const { user, updateUser } = useUser();
  const { makeApiCall } = useApiRequest();
  const hasMounted = useRef(false);

  useEffect(() => {
    if (hasMounted.current) return;
    hasMounted.current = true;

    fetchUserProfileLogic({ makeApiCall, updateUser, user });

    const interval = setInterval(() => {
      fetchUserProfileLogic({ makeApiCall, updateUser, user });
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [makeApiCall, updateUser, user]);
};

export default useFetchUserProfile;
